"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceParser = void 0;
/**
 * Space parser
 */
var SpaceParser = /** @class */ (function () {
    function SpaceParser() {
    }
    SpaceParser.prototype.test = function (sourceCode) {
        var string = sourceCode.read();
        if (!string) {
            return false;
        }
        // space without new line
        return /[^\S\n\r]/.test(string);
    };
    SpaceParser.prototype.seek = function (sourceCode) {
        while (this.test(sourceCode)) {
            sourceCode.peek();
        }
    };
    return SpaceParser;
}());
exports.SpaceParser = SpaceParser;
//# sourceMappingURL=SpaceParser.js.map